// Texty stránky Stav objednávky (orderStatusPage.js, orderStatusModel.js; plátno
// docs/design/2026-10-07-stav-objednavky/, schválené 7. 10. 2026).
import { CONTACT } from '../../modules/headerTools.js';
import { page } from '../../modules/pages.js';
import { plural } from '../plural.js';

// „do chatu" / „e-mailem": věty, které posílají za námi, se řídí tím, jestli
// stránka chat má (supportChat.js chatOn)
const MINUTES = ['minutu', 'minuty', 'minut'];
// věta končící datem („8. 10.") už tečku má
const end = (s) => (/\.$/.test(s) ? s : s + '.');
const via = (chat) => (chat ? 'do chatu' : 'na ' + CONTACT.email);

export default {
  eyebrow: 'Sledování zásilky',
  perex: 'Zadejte číslo objednávky a e-mail, který jste vyplnili při nákupu. Uvidíte, kde objednávka je a kdy dorazí.',

  form: {
    title: 'Zjistit stav objednávky',
    sub: 'Oba údaje najdete v potvrzovacím e-mailu',
    code: 'Číslo objednávky',
    codePlaceholder: 'např. 1261004387',
    email: 'E-mail',
    emailPlaceholder: 'jan.novak@email.cz',
    fromAccount: 'Předvyplnili jsme e-mail z vašeho účtu.',
    submit: 'Zobrazit stav',
    searching: 'Hledáme…',
    retry: 'Zkusit znovu',
    /** tlačítko po zámku (429) */
    lockedFor: (n) => 'Zkusit za ' + n + ' ' + plural(n, MINUTES),
    privacy: 'Bez registrace. Stav uvidí jen ten, kdo zná číslo objednávky i e-mail.',
    missingCode: 'Doplňte číslo objednávky.',
    missingEmail: 'Doplňte e-mail z objednávky.',
  },

  memory: {
    label: 'Naposledy jste hledali',
    show: 'Zobrazit stav',
    forget: 'Zapomenout',
  },

  alert: {
    notFound: {
      title: 'Objednávku jsme nenašli',
      text: 'Zkontrolujte číslo objednávky a e-mail. Platí jen e-mail, který jste vyplnili při nákupu.',
      text2: (chat) => 'Když ji pořád nenajdete, napište nám ' + via(chat) + ' a dohledáme ji.',
    },
    locked: {
      title: 'Příliš mnoho pokusů',
      text: (min, chat) =>
        'Z bezpečnostních důvodů jsme hledání na chvíli zastavili. Zkuste to znovu za ' +
        min + ' ' + plural(min, MINUTES) +
        ', nebo nám napište ' + via(chat) + '.',
    },
    outage: {
      title: 'Stav objednávky teď nedokážeme načíst',
      text: (chat) =>
        'Výpadek je na naší straně. Zkuste to za pár minut, nebo nám napište číslo objednávky ' +
        via(chat) + ' a stav vám řekneme.',
    },
    chat: 'Napsat do chatu',
    mail: 'Napsat e-mail',
  },

  loading: {
    title: (code) => 'Načítáme objednávku ' + code + '…',
    fromLink: 'Otevřeli jste odkaz z e-mailu, nic vyplňovat nemusíte.',
    fromMemory: 'Hledáme podle údajů, které jste zadali minule.',
  },

  /** „Objednávka 1261003912" (paměť, eyebrow karty stavu) */
  orderNo: (code) => 'Objednávka ' + code,
  updated: (when) => 'Aktualizováno ' + when,
  updatedAt: (day, time) => (day ? day + ' v ' + time : 'dnes v ' + time),
  staleAt: (time) => 'Stav k ' + time,
  stale: (time) => 'Údaje jsou z ' + time + '. Novější stav se teď nepodařilo načíst, zkuste stránku za chvíli obnovit.',
  refresh: 'Obnovit',

  // Karta stavu podle fáze (`stage` API + platba a způsob doručení)
  status: {
    waitTransfer: { title: 'Čeká na platbu', text: 'Údaje k platbě i QR kód najdete níže.' },
    waitTransferNoQr: { title: 'Čeká na platbu', text: 'Údaje k platbě najdete níže.' },
    waitCard: { title: 'Čeká na platbu', text: 'Platba kartou neproběhla. Zaplatit můžete znovu níže.' },
    // stav „platba se ověřuje" (CZ 25 Čeká na spárování transakce): zákazník už platil
    paymentPending: { title: 'Ověřujeme platbu', text: 'Platbu teď přiřazujeme k objednávce, znovu neplaťte. Kdyby něco nesedělo, ozveme se.' },
    // výpadek Shoptetu: stav platby ze zálohy, údaje k platbě se nezobrazí (Tomáš 9. 10. 2026)
    paymentUnverified: { title: 'Objednávka přijata', text: 'Platební údaje najdete v potvrzovacím e-mailu.' },
    received: { title: 'Objednávka přijata', text: 'Objednávku máme a brzy ji začneme chystat.' },
    preparing: {
      title: 'Připravujeme k odeslání',
      text: 'Platbu máme. Jakmile zásilku předáme dopravci, pošleme vám e-mail s číslem zásilky.',
    },
    // dobírka i nezaplacená objednávka v přípravě: text bez slibu platby (Tomáš 8. 10. 2026)
    preparingCod: {
      title: 'Připravujeme k odeslání',
      text: 'Jakmile zásilku předáme dopravci, pošleme vám e-mail s číslem zásilky.',
    },
    preparingStore: {
      title: 'Připravujeme k vyzvednutí',
      text: 'Jakmile bude objednávka na prodejně připravená, pošleme vám e-mail.',
    },
    shipped: {
      title: 'Předáno dopravci',
      text: (carrier, when) =>
        (carrier ? 'Zásilku veze ' + carrier + '.' : 'Zásilku veze dopravce.') +
        (when ? ' Doručení předpokládáme ' + end(when) : ''),
    },
    pickupReady: {
      title: 'Čeká na výdejním místě',
      text: (carrier) => 'Zásilku si můžete vyzvednout na výdejním místě' + (carrier ? ' ' + carrier : '') + '.',
    },
    storeReady: { title: 'Připraveno k vyzvednutí', text: 'Objednávka na vás čeká na prodejně v Bílině.' },
    delivered: { title: 'Doručeno', text: (when) => (when ? end('Zásilku jste převzali ' + when) : 'Objednávku jsme vyřídili.') },
    pickedUp: { title: 'Vyzvednuto', text: (when) => (when ? end('Objednávku jste vyzvedli ' + when) : 'Objednávku jsme vyřídili.') },
    cancelled: {
      title: 'Objednávka je zrušená',
      text: (when) => (when ? end('Objednávku jsme zrušili ' + when) : 'Objednávku jsme zrušili.'),
    },
    returned: { title: 'Vrácení nebo reklamace', text: 'Vrácení nebo reklamaci řešíme. O dalším postupu vám napíšeme e-mailem.' },
    processing: {
      title: 'Objednávku zpracováváme',
      text: (chat) => 'Na objednávce právě pracujeme. Kdyby vám něco nesedělo, napište nám ' + via(chat) + '.',
    },
  },

  stepsTitle: 'Průběh objednávky',
  step: {
    received: 'Objednávka přijata',
    paid: 'Zaplaceno',
    payment: 'Platba',
    waitPay: 'Čeká na platbu',
    paymentPending: 'Ověřujeme platbu',
    cod: 'Platba při převzetí',
    preparing: 'Připravujeme k odeslání',
    shipped: 'Předáno dopravci',
    pickupReady: 'Připraveno k vyzvednutí',
    pickedUp: 'Vyzvednuto',
    delivered: 'Doručeno',
    cancelled: 'Zrušeno',
    returned: 'Vrácení nebo reklamace',
  },
  stepMeta: {
    payTransfer: (amount) => 'převodem, ' + amount,
    payCard: (amount) => 'kartou online, ' + amount,
    payOther: (amount) => amount,
    cod: (amount) => 'dobírkou, ' + amount,
    afterPayment: 'po připsání platby',
    afterCard: 'po zaplacení',
    atPickup: 'na výdejním místě',
    estimate: (day) => 'předpoklad ' + day,
    store: 'prodejna Bílina',
  },

  pay: {
    title: 'Zaplaťte převodem',
    qrAlt: (amount) => 'QR kód pro platbu ' + amount,
    qrCaption: 'Naskenujte v aplikaci banky',
    amount: 'Částka',
    account: 'Číslo účtu',
    vs: 'Variabilní symbol',
    copy: (what) => 'Kopírovat ' + what,
    copyWhat: { amount: 'částku', account: 'číslo účtu', vs: 'variabilní symbol', tracking: 'číslo zásilky' },
    copied: 'Zkopírováno',
    copyFailed: 'Kopírování se nepovedlo, zkopírujte text ručně.',
    bankLine: (iban, bic) => 'IBAN ' + iban + ' · BIC ' + bic,
    note: 'Jakmile platba dorazí na účet, pošleme vám e-mail a objednávku začneme chystat.',
    cardTitle: 'Dokončete platbu kartou',
    cardText: 'Objednávku máme, chybí jen platba.',
    cardCta: (amount) => 'Zaplatit online ' + amount,
  },

  ship: {
    destPickup: 'Doručení na výdejní místo',
    destAddress: 'Doručení na adresu',
    destStore: 'Osobní odběr na prodejně',
    trackTitle: 'Zásilka',
    trackNo: 'Číslo zásilky',
    trackState: {
      in_transit: 'Na cestě',
      ready_for_pickup: 'Na výdejním místě',
      delivered: 'Doručeno',
      failed: 'Doručení se nepovedlo',
      carrier_issue: 'Dopravce řeší problém se zásilkou',
    },
    trackUpdated: (state, when) => (state ? state + ', aktualizováno ' : 'Aktualizováno ') + when,
    follow: (carrier) => (carrier ? 'Sledovat u ' + carrier : 'Sledovat zásilku'),
    estimate: 'Předpoklad doručení',
    pickupTitle: 'Kde zásilku vyzvednete',
    pickupNote: 'Jak zásilku vyzvednout, najdete ve sledování u dopravce.',
    storeTitle: 'Vyzvednutí na prodejně',
    storeName: 'Prodejna Jipos',
    openToday: (hour) => 'Dnes otevřeno do ' + hour,
    closedOpens: (when, hour) => 'Zavřeno, otevíráme ' + when + ' v ' + hour,
    map: 'Otevřít v mapách',
  },

  returns: {
    title: 'Vrácení a reklamace',
    returnTitle: 'Vrátit do 14 dnů',
    returnText: (until) => 'Bez udání důvodu. ' + (until ? end('Lhůta běží do ' + until) : 'Lhůta běží 14 dnů od převzetí.'),
    returnCta: 'Odstoupit od smlouvy',
    claimTitle: 'Reklamovat vadu',
    claimText: 'Vyřídíme nejpozději do 30 dnů, často přímo v našem servisu.',
    claimCta: 'Reklamační formulář',
  },

  /** Samoobslužné storno (přepínač orderCancel, API `order-status/cancel`) */
  abort: {
    title: 'Zrušení objednávky',
    text: 'Objednávku můžete zrušit sami, dokud ji nezačneme balit.',
    cta: 'Zrušit objednávku',
    confirm: (code) => 'Zrušit objednávku ' + code + '?',
    confirmText: 'Zrušení nejde vrátit. Potvrzení vám pošleme e-mailem.',
    yes: 'Ano, zrušit',
    no: 'Ponechat objednávku',
    working: 'Rušíme…',
    done: 'Objednávka je zrušená.',
    tooLate: (chat) => 'Objednávku už chystáme, sami ji zrušit nemůžete. Napište nám ' + via(chat) + '.',
    failed: 'Objednávku teď nejde zrušit. Zkuste to za chvíli.',
    locked: 'Příliš mnoho pokusů. Zkuste to za chvíli.',
  },

  cancelled: {
    title: 'Platba zrušené objednávky',
    text: (chat) => 'Pokud jste objednávku už zaplatili a peníze se vám zatím nevrátily, napište nám ' + via(chat) + '.',
    cta: 'Pokračovat v nákupu',
  },

  items: {
    title: 'Obsah objednávky',
    count: ['položka', 'položky', 'položek'],
    code: (code) => 'Kód ' + code,
    shipping: (name) => 'Doprava: ' + name,
    billing: (name) => 'Platba: ' + name,
    /** štítek nad názvem dárku (místo značky) */
    gift: 'Dárek',
    /** řádky souhrnu bez jména z API (sleva a poukaz se jménem neposílá) */
    extra: {
      'discount-coupon': 'Slevový kupon',
      'volume-discount': 'Množstevní sleva',
      'gift-certificate': 'Dárkový poukaz',
      service: 'Služba',
      'generic-item': 'Další položka',
      deposit: 'Záloha na obal',
      other: 'Další položka',
    },
    rounding: 'Zaokrouhlení',
    free: 'zdarma',
    totalToPay: 'Celkem k úhradě',
    totalPaid: 'Celkem zaplaceno',
    total: 'Celkem',
    vat: 'včetně DPH',
    invoice: (code) => 'Faktura ' + code,
    creditNote: (code) => 'Opravný doklad ' + code,
    pdf: 'PDF',
    download: 'Stáhnout fakturu',
    downloadCredit: 'Stáhnout doklad',
    downloading: 'Stahujeme…',
    downloadFailed: 'Doklad se teď nepodařilo stáhnout. Zkuste to za chvíli.',
    /** limit API (429) při stahování víc dokladů rychle za sebou */
    downloadLocked: 'Příliš mnoho stažení najednou. Zkuste to za minutu.',
    /** začátek jména staženého souboru („faktura-1261004387.pdf") */
    fileInvoice: 'faktura',
    fileCreditNote: 'dobropis',
  },
  /** Návody k položkám (`items[].files`, plátno návodů 9. 10. 2026, varianta A) */
  manuals: {
    title: (n) => (n > 1 ? 'Návody k vašim produktům' : 'Návod k vašemu produktu'),
    /** podtitul karty, jen když jsou všechny soubory PDF */
    sub: 'PDF otevřete v telefonu i v počítači.',
    /** „Návod k použití · PDF, 769 kB"; jméno souboru se nepíše, v adminu je nejednotné */
    meta: (file) => 'Návod k použití' + (file ? ' · ' + file : ''),
    cta: 'Stáhnout návod',
    /** odkaz „Stáhnout návody" z e-mailu, objednávka návod na e-shopu nemá (#531 U5) */
    none: 'K produktům v této objednávce tu návod zatím není. Odpovězte na náš e-mail a návod vám pošleme.',
    aria: (name, file) => 'Stáhnout návod k produktu ' + name + (file ? ' (' + file + ')' : ''),
  },
  another: 'Zadat jinou objednávku',

  whereTitle: 'Kde najdu číslo objednávky?',
  where: [
    { icon: 'mail', title: 'V potvrzovacím e-mailu', desc: 'v předmětu i v textu e-mailu, který přišel po objednání' },
    { icon: 'user', title: 'V sekci Moje objednávky', desc: 'po přihlášení do účtu', href: page('accountOrders') },
    { icon: 'file', title: 'Na faktuře', desc: 'v hlavičce dokladu' },
  ],
  whereNote: ['Číslo má 10 číslic, například ', '1261004387', '.'],

  faqTitle: 'Časté dotazy',
  faqAll: 'Všechny časté dotazy',
  faq: {
    ship: { q: 'Kdy objednávku odešlete?', a: 'Zboží skladem odesíláme v den objednání, když objednáte v pracovní den do 15:00, v pátek do 14:30. Při platbě převodem až po připsání částky na účet.' },
    shipPrep: { q: 'Kdy objednávku odešlete?', a: 'Zboží skladem odesíláme v den objednání, když objednáte v pracovní den do 15:00, v pátek do 14:30. Termín odeslání vidíte u každého produktu i v košíku.' },
    invoice: { q: 'Kdy dostanu fakturu?', a: 'Fakturu dostanete e-mailem. Když ji nemůžete najít, napište nám číslo objednávky a pošleme ji znovu.' },
    change: { q: 'Můžu objednávku zrušit nebo změnit?', a: 'Ano, dokud ji neodešleme. Napište nám co nejdřív do chatu nebo na ' + CONTACT.email + '.' },
    /** stránka nabízí storno tlačítkem (cancelOf) */
    changeSelf: {
      q: 'Můžu objednávku zrušit nebo změnit?',
      a: 'Zrušit ji můžete sami tlačítkem „Zrušit objednávku“ na této stránce, dokud ji nezačneme balit. Změnu adresy, dopravy nebo zboží vyřídíme, když nám napíšete do chatu nebo na ' + CONTACT.email + '.',
    },
    where: { q: 'Kde je můj balík a kdy dorazí?', a: 'Jakmile balík předáme dopravci, přijde vám e-mail s číslem zásilky. Cestu pak sledujete tady nebo přímo u dopravce.' },
    track: { q: 'Kde je můj balík a kdy dorazí?', a: 'Cestu zásilky sledujete přímo u dopravce. Když nedorazí v termínu, který vám dopravce poslal, napište nám číslo objednávky a zásilku dohledáme.' },
    addr: { q: 'Můžu změnit adresu nebo výdejní místo?', a: 'Odeslanou zásilku už změnit nejde. Převezměte ji a případně využijte vrácení do 14 dnů.' },
    refuse: { q: 'Co když zásilku nepřevezmu?', a: 'Nepřevzetí není odstoupení od smlouvy. Náklady na dopravu tam i zpět vám podle obchodních podmínek naúčtujeme.' },
    storeWhere: { q: 'Kde prodejnu najdu?', a: 'Na adrese Teplická 906 v Bílině. Mapu a otevírací dobu najdete na stránce Prodejna nářadí Bílina.' },
    ret: { q: 'Jak vrátím zboží do 14 dnů?', a: 'Vyplňte online formulář Odstoupení ve lhůtě 14 dnů a zboží pošlete zpět do 14 dnů od odstoupení. Peníze vracíme do 14 dnů od odstoupení, jakmile zboží dorazí zpět nebo doložíte jeho odeslání.' },
    claim: { q: 'Jak reklamuji vadné zboží?', a: 'V reklamačním formuláři vyplníte číslo objednávky, e-mail a popis závady, pomůže i fotka nebo video. Reklamaci vyřídíme nejpozději do 30 dnů.' },
    warranty: { q: 'Jak dlouhá je záruka?', a: 'U spotřebního zboží můžete vadu vytknout do dvou let od převzetí. Záruční i pozáruční opravy děláme ve vlastní dílně.' },
    pay: { q: 'Jak můžu zaplatit?', a: 'Kartou online, bankovním převodem nebo dobírkou při převzetí. Přehled je na stránce Doprava a platba.' },
  },

  help: {
    form: {
      title: 'Něco nesedí?',
      text: 'Nemůžete objednávku najít nebo vám stav nesedí? Ozvěte se, hned se na to podíváme.',
    },
    pre: {
      title: 'Potřebujete objednávku zrušit nebo změnit?',
      text: (chat) =>
        chat
          ? 'Dokud ji neodešleme, zrušíme ji nebo upravíme. Napište nám do chatu, číslo objednávky doplníme za vás.'
          : 'Dokud ji neodešleme, zrušíme ji nebo upravíme. Napište nám e-mail, číslo objednávky doplníme za vás.',
    },
    // zrušit jde tlačítkem na stránce (cancelOf), panel nabízí jen změnu
    preCancel: {
      title: 'Potřebujete objednávku změnit?',
      text: (chat) =>
        chat
          ? 'Adresu, dopravu nebo zboží upravíme, dokud objednávku neodešleme. Napište nám do chatu, číslo objednávky doplníme za vás.'
          : 'Adresu, dopravu nebo zboží upravíme, dokud objednávku neodešleme. Napište nám e-mail, číslo objednávky doplníme za vás.',
    },
    post: {
      title: 'Něco nesedí?',
      text: (chat) =>
        chat
          ? 'Napište nám do chatu nebo e-mailem, číslo objednávky doplníme za vás.'
          : 'Napište nám e-mail, číslo objednávky doplníme za vás.',
    },
    chat: 'Napsat do chatu',
    mail: 'Napsat e-mail',
    hours: (text) => 'Podpora ' + text,
    /** předmět e-mailu s číslem objednávky */
    subject: (code) => 'Objednávka ' + code,
    /** předvyplněná zpráva chatu (supportChat.js setChatContact): agent chatu proměnné widgetu nevidí */
    chatDraft: (code, email) => 'Objednávka ' + code + ', e-mail ' + email + ': ',
  },

  // Data: dny v týdnu (0 = neděle) pro „čtvrtek 8. 10.", „předpoklad čt 8. 10.",
  // „do pátku 16. 10."; „ve čtvrtek" bere model z dispatchEta.days
  dayName: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
  dayAbbr: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
  dayUntil: ['neděle', 'pondělí', 'úterý', 'středy', 'čtvrtka', 'pátku', 'soboty'],
  today: 'dnes',

  /** kód dopravce z API (`logistics-<kód>-…`) → jméno */
  carriers: { ppl: 'PPL', gls: 'GLS', fofr: 'Fofr', zasilkovna: 'Zásilkovna', dpd: 'DPD', cp: 'Česká pošta', balikovna: 'Balíkovna' },
  /** název metody dopravy (text Shoptetu) → kód dopravce, když API kód nenese */
  carrierRe: [
    [/\bPPL\b/i, 'ppl'],
    [/\bGLS\b/i, 'gls'],
    [/\bfofr\b/i, 'fofr'],
    [/z[áa]silkovn|packeta/i, 'zasilkovna'],
    [/\bDPD\b/i, 'dpd'],
    [/bal[íi]kovn/i, 'balikovna'],
    [/[čc]esk[áa]\s+po[šs]ta/i, 'cp'],
  ],
  /** název metody → osobní odběr na prodejně */
  storeRe: /osobn[íi]\s*odb[ěe]r|prodejn/i,
};
